export default class CompliantConsentManager {
    constructor() {
        this.queue = [];
        this.essentialCookieName = "tessellate_necessary_consent";

        const consent = this.getConsentFromCookie();
        this.consentGranted =
            !!consent && Object.values(consent).some((v) => v === "granted");
        this.savedConsent = consent || {
            ad_storage: "denied",
            analytics_storage: "denied",
            ad_user_data: "denied",
            ad_personalization: "denied",
            meta: "denied",
        };

        this.initializeConsent();
    }

    getConsentFromCookie() {
        const match = document.cookie
            .split("; ")
            .find((row) => row.startsWith(`${this.essentialCookieName}=`));

        if (!match) return null;

        try {
            const jsonStr = decodeURIComponent(match.split("=")[1]);
            return JSON.parse(jsonStr);
        } catch (e) {
            console.warn("Consent cookie is invalid:", e);
            return null;
        }
    }

    setConsentCookie(consent) {
        const date = new Date();
        date.setFullYear(date.getFullYear() + 1);
        const cookieValue = encodeURIComponent(JSON.stringify(consent));
        document.cookie = `${
            this.essentialCookieName
        }=${cookieValue}; expires=${date.toUTCString()}; path=/; SameSite=Lax`;
    }

    initializeConsent() {
        let cookieConsent = this.getConsentFromCookie();

        if (this.getConsentFromCookie()) {
            // cookie isset
            cookieConsent = this.getConsentFromCookie();
            if (cookieConsent) {
                this.savedConsent = cookieConsent;
                if (this.savedConsent.ad_storage === "granted") {
                    const adStorage = document.getElementById("ad_storage");
                    if (adStorage) {
                        adStorage.checked = true;
                    }
                }
                if (this.savedConsent.analytics_storage === "granted") {
                    document
                        .getElementById("analytics_storage")
                        .setAttribute("checked", "true");
                }
                if (this.savedConsent.meta === "granted") {
                    const metaElm = document.getElementById("meta");
                    if (metaElm) {
                        metaElm.checked = true;
                    }
                }
            }
        }

        window.gtag("consent", "default", {
            ...this.savedConsent,
            wait_for_update: 500,
        });

        if (this.consentGranted) {
            this.processQueue();
        }
    }

    grantConsent() {
        if (this.consentGranted) return;

        const wasAnalyticsGranted =
            this.savedConsent.analytics_storage === "granted";
        const newConsent = {
            ad_storage: "granted",
            analytics_storage: "granted",
            ad_user_data: "granted",
            ad_personalization: "granted",
            meta: "granted",
        };

        //grant access to pixel using pixel your site
        if (site_data.meta == "yes") {
            if (window.pys) {
                window.pys.Facebook.loadPixel();
            }
        }

        this.savedConsent = newConsent;
        this.setConsentCookie(newConsent);

        window.gtag("consent", "update", newConsent);
        this.processQueue();
        this.consentGranted = true;

        // Trigger page view if analytics consent was newly granted
        if (!wasAnalyticsGranted) {
            this.triggerPageView();
        }

        document.getElementById("tessellate-consent-banner").style.display =
            "none";

        if (site_data.meta == "yes") {
            const metaElm2 = document.getElementById("meta");
            if (metaElm2) {
                metaElm2.checked = true;
            }
        }
        document
            .getElementById("analytics_storage")
            .setAttribute("checked", "true");

        const adStorage2 = document.getElementById("ad_storage");
        if (adStorage2) {
            adStorage2.checked = true;
        }
    }

    updateConsent(consentUpdates) {
        if (typeof consentUpdates !== "object" || consentUpdates === null) {
            throw new Error("Consent updates must be an object.");
        }

        const wasAnalyticsGranted =
            this.savedConsent.analytics_storage === "granted";

        const updatedConsent = { ...this.savedConsent };

        for (const [key, value] of Object.entries(consentUpdates)) {
            if (value === "granted" || value === "denied") {
                updatedConsent[key] = value;
            } else {
                console.warn(`Invalid consent value for ${key}: ${value}`);
            }
        }

        this.savedConsent = updatedConsent;
        this.setConsentCookie(updatedConsent);

        window.gtag("consent", "update", updatedConsent);
        this.processQueue();

        console.log("Updated consent:", updatedConsent);

        //grant access to pixel using pixel your site
        if (site_data.meta == "yes") {
            if (updatedConsent.meta === "granted" && window.pys) {
                if (window.pys) {
                    window.pys.Facebook.loadPixel();
                    document
                        .getElementById("meta")
                        .setAttribute("checked", "true");
                }
            }
        }

        this.consentGranted = Object.values(updatedConsent).some(
            (v) => v === "granted"
        );

        // Trigger page view if analytics consent was newly granted
        const isAnalyticsGrantedNow =
            updatedConsent.analytics_storage === "granted";
        if (!wasAnalyticsGranted && isAnalyticsGrantedNow) {
            this.triggerPageView();
        }
    }

    revokeConsent() {
        this.consentGranted = false;

        this.savedConsent = {
            ad_storage: "denied",
            analytics_storage: "denied",
            ad_user_data: "denied",
            ad_personalization: "denied",
        };

        document.cookie = `${this.essentialCookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;

        window.gtag("consent", "update", this.savedConsent);

        this.queue = [];
    }

    sendEvent(eventName, eventParams = {}) {
        const eventData = {
            event_name: eventName,
            ...eventParams,
        };

        if (this.consentGranted) {
            window.gtag("event", eventName, eventParams);
        } else {
            this.queue.push(eventData);
        }
    }

    processQueue() {
        while (this.queue.length > 0) {
            const event = this.queue.shift();
            window.gtag("event", event.event_name, event);
        }
    }

    triggerPageView() {
        window.gtag("event", "page_view", {
            page_title: document.title,
            page_location: window.location.href,
            page_path: window.location.pathname,
            send_to: site_data.analytics, // set in config
        });
    }
}
